
// 品牌制造
const brandLangCN = {
    BrandManufacturing:"品牌制造",
    BrandDirectSupplier:"品牌直供商"
}

const brandLangEN = {
    BrandManufacturing:"Brand manufacturing",
    BrandDirectSupplier:"Brand direct supplier"
}

const langPackage = {
    cn:brandLangCN,
    en:brandLangEN
}

export {langPackage}
